<!-- Template -->

<template>   
   <div class="header">

        <!-- <a @click.prevent="$router.push('/hospitals/' + $route.params.hospital + '/systems')" class="close-system do-resize" > -->
            <!-- <span class="icon-chevron-left"></span> -->
            <h2 ref="headerTitle" :class="{big: system.productConfigurationDescription.length > 30, bigger: system.productConfigurationDescription.length > 40}">{{system.productConfigurationDescription}}</h2>
        <!-- </a> -->
        
        <!-- <RequestSupportButton/>  -->

    </div>
</template>

<!-- Script -->

<script>
    //import RequestSupportButton from '@/components/RequestSupportButton';

    export default {
        name: 'SystemsHeader',

        // components: {
        //     RequestSupportButton
        // },

        props: ["system", "hospital"]
    }
</script>

